import Vue from 'vue'
import axios from 'axios';
import * as _ from 'lodash';

export const TYPE_AREA = 10;
export const TYPE_RESTAURANT = 20;
export const STATUS_RESTAURANT_ACTIVE = 10;

export default {
    state: {
        cities: [],
        areas: [],
        locations: [],
    },
    mutations: {
        fetchAreas(state, payload) {
            // default order by area name
            state.areas = _.orderBy(payload, area => area.name);
            // console.log('fetchAreas mutation',state.areas);
        },
        fetchLocations(state, payload) {
            state.locations = payload;
        },
        fetchCities(state, payload) {
            state.cities = payload;
        },
        setAreas(state, payload) {
            state.areas = payload;
        },
        addAreaToList(state, payload) {
            payload.restaurants = [];
            (state.areas).push(payload);
            localStorage.setItem('areas',JSON.stringify(state.areas));
        },
        addArea(state, payload){
            state.areas.push(payload);
            localStorage.setItem('areas',JSON.stringify(state.areas));
        },
        removeArea(state, payload) {
            for (let i = 0; i < state.areas.length; i++) {
                if (payload.id == state.areas[i].id) {
                    state.areas.splice(i, 1); // remove item
                    break; // founded exit
                }
            }
        },
        editArea(state, payload){
            const index = state.areas.findIndex(item => item.id === payload.id);
            Vue.set(state.areas, index, payload);
            localStorage.setItem('areas',JSON.stringify(state.areas));
        },
        // -- Areas page methods:
        addAreaRestaurant(state, payload) {
            state.areas.forEach(area => {
                if (area.id === payload.areaId) {
                    if(area.restaurants){
                        area.restaurants.push(payload);
                    }
                }
            });
        },
        deleteAreaRestaurant(state, payload) {
            state.areas.forEach(area => {
                if (area.restaurants) {
                    area.restaurants.map((restaurant, index) => {
                        if (restaurant.id == payload.id) {
                            area.restaurants.splice(index, 1);
                        }

                    })
                }
            });
        },
        editAreaRestaurant(state, payload) {
            state.areas.forEach(area => {
                if (area.restaurants) {
                    area.restaurants.map((restaurant, index) => {
                        if (restaurant.id == payload.id) {
                            Vue.set(area.restaurants, index, payload);
                        }
                    })
                }
            });
        }
    },

    actions: {
        async fetchAreas({ commit, dispatch }) {
            if (!this.state.drivers.promisesStatus.fetchAreas) {
                commit('clearError')
                commit('setLoading', true);

                let user = JSON.parse(localStorage.getItem("user"));
                try {
                    let { data } = await axios.get(`${this._vm.appConfig.app_url}/api/area`, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            "Authorization": `Bearer ${user.access_token}`
                        }
                    });

                    commit('setLoading', false);
                    commit('fetchAreas', data);
                    commit('setPromiseStatus', { promiseName: 'fetchAreas', status: true });
                } catch(error) {
                    commit('setLoading', false);

                    if (error.response) {
                        let errors = error.response;
                        if(errors.status == 401){
                            dispatch('logOutUser');
                            window.location.reload();
                        }
                        if(errors.status == 400) {
                            dispatch('setError', _.values(errors.data)[0][0]);
                            return Promise.reject(errors.data);
                        }
                    }

                    if (error.message) {
                        dispatch('setError', error.message);
                    } else {
                        dispatch('setError', error);
                    }
                }
            }
            // console.log('fetchAreas actions', this.state.areas);
        },
        async fetchCities({ commit, dispatch }) {
            if (!this.state.drivers.promisesStatus.fetchCities) {
                commit('clearError')
                commit('setLoading', true);

                let user = JSON.parse(localStorage.getItem("user"));
                try {
                    let { data } = await axios.get(`${this._vm.appConfig.app_url}/api/city`, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            "Authorization": `Bearer ${user.access_token}`
                        }
                    });

                    commit('setLoading', false);
                    commit('fetchCities', data);
                    commit('setPromiseStatus', { promiseName: 'fetchCities', status: true });
                } catch(error) {
                    commit('setLoading', false);

                    if (error.response) {
                        let errors = error.response;
                        if (errors.status == 401) {
                            dispatch('logOutUser');
                            window.location.reload();
                        }
                        if(errors.status == 400) {
                            dispatch('setError', _.values(errors.data)[0][0]);
                            return Promise.reject(errors.data);
                        }
                    }

                    if (error.message) {
                        dispatch('setError', error.message);
                    } else {
                        dispatch('setError', error);
                    }
                }
            }
        },
        async fetchLocations({ commit, dispatch }) {
            // load data async:
            await Promise.all([
                dispatch('fetchAreas'),
                dispatch('fetchRestaurants')
            ]);

            // make locations from areas and restaurants
            let locations = [];
            _.each(this.getters.areas, area => {
                // push area
                area._guid = { // fix, group unique id for select
                    id: area.id,
                    type: TYPE_AREA
                };

                locations.push(area);

                // push area's restaurants
                let restaurants = _.filter(this.getters.restaurants, p => area.id == p.area_id && p.status === STATUS_RESTAURANT_ACTIVE);

                _.each(restaurants, restaurant => {
                    restaurant._guid = {
                        id: restaurant.id,
                        type: TYPE_RESTAURANT
                    };

                    locations.push(restaurant);
                });
            });

            commit('fetchLocations', locations);
        },

        async createNewArea({commit, dispatch}, payload) {
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let { data } = await axios.post(`${this._vm.appConfig.app_url}/api/area`, payload, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('setLoading', false);
                commit('addAreaToList', data)
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }

                throw error
            }
        },

        async removeArea({commit, dispatch}, payload) {
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let { data } = await axios.delete(`${this._vm.appConfig.app_url}/api/area/${payload.id}`, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('setLoading', false);
                commit('removeArea', data);
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }

                throw error
            }
        },

        async editArea({commit, dispatch}, payload) {
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let { data } = await axios.put(`${this._vm.appConfig.app_url}/api/area/${payload.id}`, payload, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('editArea', data)
                commit('setLoading', false)
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }

                throw error
            }
        }

    },

    getters: {
        areas (state) {
            return state.areas
        },
        cities (state) {
            return state.cities
        },
        locations (state) {
            return state.locations;
        }

    }
}
